/* eslint-disable  */
// eslint-disable-next-line import/named
import { Details } from '@material-ui/icons';
import { API_EVENTS, DISCOUNT } from '../constants/actionTypes';

export const initialState = {
  loading: false,
  companyId: null,
  handleNext: false,
  data: null,
  error: null,
};

const calDiscount = (amount, details) => {
  if (details.priceEvent === '0') {
    amount = parseFloat(amount - details.amount);
  } else if (details.priceEvent === '1') {
    amount = parseFloat(amount - (amount * details.amount) / 100);
  }
  return amount >= 0 ? amount : 0;
};

const discountCalculation = (state, details) => {
  let modifiedData = { ...state.data };
  if (details?.amount) {
    let discountPackage = [];
    let packageSelection = '';
    if (details.classpack && state.data.classPack.length > 0) {
      packageSelection = 'classpack';
      discountPackage = state.data.classPack;
    }
    if (details.membership && state.data.membership.length > 0) {
      packageSelection = 'membership';
      discountPackage = state.data.membership;
    }
    const modClasspack = discountPackage.reduce((acc, item) => {
      let discountedAmt = item.price;
      let discountedFirstAmt = item.price;

      if (details.packageId.includes(item._id.toString())) {
        if (packageSelection == 'membership' && item.isAutoPay === '1') {
          if (details.appliedMonth == 1) {
            discountedFirstAmt =
              details.appliedMonth === '1' && item.diffFirstMonthPrice === '1'
                ? item.firstMonthPrice
                : item.price;
            discountedFirstAmt = calDiscount(discountedFirstAmt, details);
            discountedAmt = calDiscount(discountedAmt, details);
          } else {
            discountedFirstAmt =
              details.appliedMonth == 0 && item.diffFirstMonthPrice === '1'
                ? item.firstMonthPrice
                : item.price;
            discountedFirstAmt = calDiscount(discountedFirstAmt, details);
            discountedAmt = calDiscount(discountedAmt, details);
          }
        } else {
          discountedAmt = calDiscount(discountedAmt, details);
        }
      }

      acc.push({
        ...item,
        quantity: 1,
        amount: discountedAmt,
        firstMonthPrice: discountedFirstAmt,
      });

      return acc;
    }, []);

    if (packageSelection == 'classpack') {
      modifiedData = { ...modifiedData, classPack: modClasspack, orderTotal: details.orderTotal };
    } else if (packageSelection == 'membership') {
      modifiedData = { ...modifiedData, membership: modClasspack, orderTotal: details.orderTotal };
    }
  }
  return { ...state, data: modifiedData };
};

const clientSignupReducer = (state, { type, payload }) => {
  switch (type) {
    case API_EVENTS.REQUEST:
      return { ...state, loading: true, handleNext: false };

    case API_EVENTS.FAIL:
      return { ...state, loading: false, error: payload };

    case API_EVENTS.SUCCESS:
      return {
        ...state,
        loading: false,
        handleNext: payload?.handleNext,
        data: { ...state.data, ...payload },
      };
    case DISCOUNT.SUCCESS:
      return discountCalculation(state, payload);

    case API_EVENTS.RESET:
      return initialState;

    case 'COMPANY_ID':
      return { ...state, companyId: payload };

    default:
      return state;
  }
};

export default clientSignupReducer;
